function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, customPropTypes, getComponentType, getUnhandledProps, SUI } from '../lib';

/**
 * Several icons can be used together as a group.
 */
var IconGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    content = props.content,
    size = props.size;
  var classes = cx(size, 'icons', className);
  var rest = getUnhandledProps(IconGroup, props);
  var ElementType = getComponentType(props, {
    defaultAs: 'i'
  });
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
IconGroup.displayName = 'IconGroup';
IconGroup.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,
  /** Size of the icon group. */
  size: PropTypes.oneOf(_.without(SUI.SIZES, 'medium'))
};
export default IconGroup;
//# sourceMappingURL=IconGroup.js.map